<template>
    <v-container>
        <div v-if="hasPermission('MIETSPIEGEL_BACKEND_WRITE_BERECHNUNGSVORLAGE')" class="d-flex justify-left my-3">
            <v-btn v-on:click="save" outlined large color="indigo" aria-labelled-by="Speichern"><span class="black--text subtitle-1">Speichern</span></v-btn>
        </div>
        <div class="my-3">
            <h1 class="uiTitle header">
                Verfügt die Wohnung über eine offene Küche?
            </h1>
        </div>
        <div class="mb-5">
            <p class="validationError" role="alert" v-if="validationError">
                <v-icon style="color:#c50517">mdi-alert</v-icon><strong>Bitte wählen Sie eine Option aus!</strong>
            </p>
            <v-card class="d-flex justify-center"
                outlined
            >
                <v-list class="py-0" style="width:100%" role="group">
                    <v-list-item-group role="list" tabindex="0" :aria-active-descendant="selectedItem" v-model="selectedItem" color="transparent" active-class="list-selected">
                        <template v-for="(item, index) in items">
                            <v-divider
                                v-if="item.divider"
                                :key="index"
                                aria-hidden="true"
                            ></v-divider>
                            <v-list-item
                                v-else
                                :key="index"
                                tabindex="-1"
                                :id="item.id"
                                v-on:dblclick="selectAndNext(item.id)"
                            >
                                <input class="d-flex justify-center" @focus="focusInputParent" type="radio" tabindex="-1" :checked="isSelected(item.id)" :title="$t('kueche.' + item.id)">
                                <v-list-item-content aria-hidden="true" style="color: black; margin-left: 8px">
                                    <v-list-item-title v-html="$t('kueche.' + item.id)"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </div>
        <!-- BUTTON SECTION -->
        <div class="d-flex justify-center justify-space-around my-3">
            <v-btn v-on:click="back" outlined large color="indigo" aria-labelled-by="Zurück"><span class="black--text subtitle-1">Zurück</span></v-btn>
            <v-btn v-on:click="next" outlined large color="indigo" aria-labelled-by="Weiter"><span class="black--text subtitle-1">Weiter</span></v-btn>
        </div>
        <!-- INFO SECTION -->
        <div>
            <v-card class="d-flex justify-center mt-6" outlined color="indigo" hover>
                <v-expansion-panels>
                    <v-expansion-panel ref="infoPanel">
                        <v-expansion-panel-header @click="changedExpansion" v-if="expanded" aria-label="Info-Bereich Schließen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-header @click="changedExpansion" v-else aria-label="Info-Bereich Öffnen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3>Offene Küche</h3><br/>
                            <p>Wohnung verfügt über eine zum Ess-/Wohnraum offene Küche (Funktion: Kochen, Essen, Wohnen. Der 
                                Küchenbereich ist optisch und funktional vom Ess-/Wohnbereich eindeutig unterscheidbar.). Die 
                                Ausstattung der Küche spielt dabei keine Rolle. Eine im Wohnraum integrierte Kochnische oder 
                                Kochgelegenheit fällt nicht unter das Merkmal „Offene Küche“.</p>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </div>
    </v-container>
</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';
    import { EventBus } from '../eventbus';
    import { createNamespacedHelpers } from 'vuex';

    const { mapMutations } = createNamespacedHelpers('berechnung')
    const { mapGetters } = createNamespacedHelpers('user')

    @Component({
        computed: { ...mapGetters(['hasPermission']) },
        methods: { ...mapMutations(['SET_SELECTED_KUECHE']) }
    })
    export default class Kueche extends Vue {

        data() {
            return {
                index: 10,
                selectedItem: this.$store.state.berechnung.selectedKueche,
                items: [
                    { id: 0 },
                    { divider: true},
                    { id: 1 },
                ],
                validationError: false,
                expanded: false
            };
        }

        focusInputParent(event){
            //only triggered by screenreader
            event.target.parentElement.focus()
            event.preventDefault()
        }

        changedExpansion(event){
            this.expanded = !this.expanded
            event.currentTarget.setAttribute('aria-expanded', this.expanded)
        }

        isSelected(index) {
            return index == this.selectedItem;
        }

        selectAndNext(id) {
            this.$data.selectedItem = id;
            this.next();
        }

        mounted() {
            EventBus.$emit('scroll', this.$data.index)
            this.$refs.infoPanel.$el.firstChild.setAttribute('aria-expanded', false)
            var vm = this;
            const listgroup = document.querySelector('[role="group"]').firstChild
            listgroup.addEventListener('focus', event => {
                event.target.firstChild.focus()
            })
            //item group handling: (un)select on spacebar
            listgroup.addEventListener('keydown', event => this.itemSelection(event, vm))
        }

        itemSelection(event, vm){
            if(event.key !== ' ') return
            const option = event.target.closest('.v-list-item')
            if (!option) return
            const id = parseInt(option.id)
            if(vm.selectedItem === id){
                setTimeout(function(){
                    vm.selectedItem = null
                }, 100)
            }else{
                setTimeout(function(){
                    vm.selectedItem = id
                }, 100)
            }
            event.preventDefault()
        }

        save() {
            EventBus.$emit('getSaveData', this.index)
        }

        next() {
            this.validationError = (this.selectedItem == undefined || this.selectedItem == null);
            if(this.validationError) {
                let alert = document.querySelector('.validationError')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
                return;
            }
            console.log(this.selectedItem)
            this.SET_SELECTED_KUECHE(this.selectedItem)
            this.$router.push('kuechengrundausstattung')
        }

        back() {
            this.$router.push('sanitaerbereich')
        }
    }
</script>
